import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

//types
import { CandidateData } from '../../types/types';

type CandidateProps = {
    candidate: CandidateData;
}

const Candidate = ({ candidate }: CandidateProps) => {

    const { name, party, showCandidateData, urlImageCandidate }: CandidateData = candidate;

    return (
        <section className="col-6 py-4 text-center">
            <div className="d-flex justify-content-center align-items-center mb-3 mx-auto rounded-circle border-dark-grey content-candidate bg-lightgrey-candidate">
            {showCandidateData && 
                <LazyLoadImage
                    alt={name}
                    className="img-fluid"
                    effect="blur"
                    src={urlImageCandidate}
                />
            }
            </div>
            {showCandidateData && 
                <article>
                    <h4 className="mb-0 home-candidate-name">{name}</h4>
                    <h6 className="my-2 text-party-circle home-party">{party}</h6>
                </article>            
            }
        </section>
    )
}

export default Candidate;